import ENV from "config/Env";
import { backendQueryKey, localQueryKey } from "hooks/useTypedQuery";

import type { StatusFilter } from "components";
import type { PIN_STATUSES, PIN_TYPES, Pin, QUESTION_RESULT_STATUSES } from "models";
import type { ORDER_BY, ORDER_BY_LOCATION, WARRANTY_TIME_PERIODS } from "modules/WarrantyDashboard/hooks";
import type { PAGE_SIZE } from "utils/common";
import type { PaginatedItems } from "utils/paginatedItems";

const component = "WarrantyDashboard";

export type WarrantyDashboardFilters = {
  appointment_statuses: StatusFilter[];
  brands: null | string[];
  claimed: boolean;
  deleted: boolean;
  pin_date_from: string | null;
  pin_date_to: string | null;
  appointment_date_from: string | null;
  appointment_date_to: string | null;
  dealer_ids: number[];
  location_ids: number[];
  mechanic_fixed: boolean | null;
  order_by: ORDER_BY | null;
  page: number;
  pin_status_id: null | PIN_STATUSES[];
  pin_type_id: PIN_TYPES[] | null;
  search_term: string;
  status: QUESTION_RESULT_STATUSES | null;
  warranty_type_id: number | null;
  claim_order_by: ORDER_BY | null;
  time_period: WARRANTY_TIME_PERIODS;
  appointment_time_period: WARRANTY_TIME_PERIODS;
  pin_status_refresh_timestamp: string | null;
  order_by_location: ORDER_BY_LOCATION | null;
  page_size: PAGE_SIZE;
};

export const WarrantyQueryKeys = {
  isExportModalOpen: localQueryKey<boolean>({ component, data: "isExportModalOpen" }),
  dashboardFilters: localQueryKey<WarrantyDashboardFilters>({ component, data: "dashboardFilters" }),
  pinHistory: backendQueryKey<Pin[]>({ component, baseUrl: ENV.appointmentBaseURL, endpoint: "/pins/view" }),
  listWarranties: backendQueryKey<PaginatedItems<Pin>>({ component, baseUrl: ENV.appointmentBaseURL, endpoint: "/pins/list" })
};
